import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between h-full" }
const _hoisted_2 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_3 = { class: "max-w-[1040px]" }
const _hoisted_4 = { class: "grid gap-5 sm:grid-cols-2" }

import { computed, onMounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'

import api from '@/store/api'

import { mapRelationship } from '@/store/mappers'


export default {
  __name: 'ReferralNeue',
  setup(__props) {

const router = useRouter()

const loading = ref(true)
const program = ref(null)
const discountTemplate = computed(() => mapRelationship(program.value?.relationships.discount_code_template.data))
const messageTemplate = computed(() => mapRelationship(program.value?.relationships.message_template.data))

const local = reactive({
  dirty: false,
  enabled: false,
  type: '',
  message: '',
  rewardAmount: '',
  rewardPercentage: '',
  explanation: ''
})

onMounted(async () => {
  let response = await api.call('GET', 'referral_discount_programs')
  program.value = response.data.data[0]
  if (!response.data.data.length) {
    response = await api.call('POST', 'referral_discount_programs', {
      referral_discount_program: { is_active: true, discount_code_template_attributes: { is_active: true } }
    })
    program.value = response.data.data
  }
  loading.value = false
  resetLocal()
})

const resetLocal = () => {
  local.enabled = program.value.attributes.turned_on
  local.type = program.value.attributes.reward_type
  local.message = messageTemplate.value?.attributes.body
  local.rewardAmount = (program.value.attributes.referrer_reward.cents / 100).toFixed(2)
  local.rewardPercentage = program.value.attributes.referral_reward_percentage
  local.explanation = program.value.attributes.explanation
  local.dirty = false
}

const toggleEnabled = () => {
  api.call('PUT', 'referral_discount_programs/' + program.value.id, {
    referral_discount_program: {
      turned_on: local.enabled
    }
  })
}

const save = () => {
  api.call('PUT', 'referral_discount_programs/' + program.value.id, {
    referral_discount_program: {
      is_active: true,
      reward_type: local.type,
      message_template_attributes: {
        id: messageTemplate.value?.id,
        body: local.message
      },
      referrer_reward_cents: local.rewardAmount * 100,
      referral_reward_percentage: local.rewardPercentage,
      explanation: local.explanation
    }
  })
  local.dirty = false
}

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_SaveBar = _resolveComponent("SaveBar")
  const _component_NeueToggle = _resolveComponent("NeueToggle")
  const _component_SettingsSection = _resolveComponent("SettingsSection")
  const _component_InputArea = _resolveComponent("InputArea")
  const _component_SelectInput = _resolveComponent("SelectInput")
  const _component_InputField = _resolveComponent("InputField")
  const _component_RouterLink = _resolveComponent("RouterLink")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, {
        text: "Referral program",
        "save-status": true,
        sections: [
          {
            id: 'overview',
            name: 'Overview',
            action: () => _unref(router).push('/store/referral-program')
          },
          {
            id: 'codes',
            name: 'Referral codes',
            action: () => _unref(router).push('/store/referral-program/codes')
          },
          {
            id: 'settings',
            name: 'Settings',
            active: true
          }
        ]
      }, null, 8, ["sections"])
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_SaveBar, {
            "has-unsaved-changes": local.dirty,
            onOnDiscard: resetLocal,
            onOnSave: save
          }, null, 8, ["has-unsaved-changes"]),
          _createVNode(_component_NeueLoading, { loading: loading.value }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_SettingsSection, {
                  title: "Referral program",
                  description: "Every customer gets a unique discount code to share. New customers get a discount, and the referrer earns account credit each time their code is used.",
                  flush: ""
                }, {
                  default: _withCtx(() => [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "min-w-0" }, [
                      _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Turned on"),
                      _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, "Off means no codes are shown or rewarded.")
                    ], -1)),
                    _createVNode(_component_NeueToggle, {
                      modelValue: local.enabled,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((local.enabled) = $event)),
                      onChange: toggleEnabled
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_SettingsSection, {
                  title: "Explanation",
                  description: "Shown on the receipt and profile screens next to each customer's code, so they know how to share it."
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputArea, {
                      modelValue: local.explanation,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((local.explanation) = $event)),
                      name: "Referral program explanation for receipt/profile",
                      onInput: _cache[2] || (_cache[2] = $event => (local.dirty = true))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_SettingsSection, {
                  title: "Referrer reward",
                  description: "The account credit a customer earns after someone uses their code at checkout."
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_SelectInput, {
                        modelValue: local.type,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((local.type) = $event)),
                        name: "Type",
                        options: [
                      { name: 'Set amount', value: 'set-amount' },
                      { name: 'Percentage', value: 'percentage' }
                    ],
                        onInput: _cache[4] || (_cache[4] = $event => (local.dirty = true))
                      }, null, 8, ["modelValue"]),
                      (local.type === 'set-amount')
                        ? (_openBlock(), _createBlock(_component_InputField, {
                            key: 0,
                            modelValue: local.rewardAmount,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((local.rewardAmount) = $event)),
                            name: "Account credit granted to referrer",
                            prefix: "$",
                            onInput: _cache[6] || (_cache[6] = $event => (local.dirty = true))
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      (local.type === 'percentage')
                        ? (_openBlock(), _createBlock(_component_InputField, {
                            key: 1,
                            modelValue: local.rewardPercentage,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((local.rewardPercentage) = $event)),
                            name: "Account credit granted to referrer",
                            suffix: "%",
                            onInput: _cache[8] || (_cache[8] = $event => (local.dirty = true))
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_SettingsSection, {
                  title: "Thank-you message",
                  description: "Sent to the referrer when their code is used, letting them know they've been issued account credit."
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputArea, {
                      modelValue: local.message,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((local.message) = $event)),
                      name: "Referrer thank you message",
                      onInput: _cache[10] || (_cache[10] = $event => (local.dirty = true))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_SettingsSection, {
                  title: "New customer discount",
                  description: "The discount a new customer gets when they check out with a referral code."
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_RouterLink, {
                      to: '/store/discount-codes/' + discountTemplate.value?.id,
                      class: "text-sm text-blue-600"
                    }, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode(" Edit the discount type and amount offered ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

}